/* eslint-disable no-unused-vars */
import React from "react";
import { BiCopy } from "react-icons/bi";
import { IoMdDocument } from "react-icons/io";
import { useProject } from "../context/ProjectContext";

const Project = () => {

  const { projects, setSelectedProject, selectedProject } = useProject();

  return (
    <div className="w-[80%] pb-5">
      <div>
        <p className="py-5 text-primary font-semibold">Current Projects</p>
        {projects.map((project, i) => {
          return (
            <div key={i} className={`flex justify-between items-center border-2 py-6 px-5 rounded-xl mb-3 ${selectedProject?.id === project?.id && 'border-primary shadow-md'}`}>
              <div className="flex items-center gap-4">
                {(project?.media && project?.media.length > 0) ? <img className="h-10 w-10 rounded-full" src={project?.media[0]} alt="" /> : <div className="py-3 px-3 rounded-full border border-gray-400">
                    <IoMdDocument className="text-xl" />
                  </div>}
                <div>
                  <p className="text-sm font-semibold">{project?.contractor?.contractorName}</p>
                  <p className="text-xs text-primary">last update {project?.lastUpdate}</p>
                </div>
              </div>
              <div onClick={() => setSelectedProject(project)} className="flex items-center gap-2 border-2 py-2 px-5 rounded-lg border-primary text-primary text-sm">
                <BiCopy />
                <p>Open</p>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default Project;
